// TODO POD6DJ-3299 - Remove temporary overrides for new Hamburg Alstertal
//  The new Hamburg Alstertal (siteId 190) carries its real hyphenatedClubName 'hamburg-alstertal',
//  but uses the data folder 'alstertal' because the existing Meridian club (siteId 139) uses
//  the 'hamburg-alstertal' folder until. Once 139 is rebranded, delete this module and its call
//  sites, then rename data/alstertal[_en-de] -> data/hamburg-alstertal[_en-de].
const DATA_FOLDER_OVERRIDES_BY_SITE_ID: Record<string, string> = {
  '190': 'alstertal',
};

export const getDataFolderOverrideForSiteId = (siteId: string): string | null =>
  DATA_FOLDER_OVERRIDES_BY_SITE_ID[siteId] ?? null;

export const getSiteIdForOverriddenDataFolder = (dataFolderName: string): string | null =>
  Object.entries(DATA_FOLDER_OVERRIDES_BY_SITE_ID).find(
    ([, folderName]) => folderName === dataFolderName
  )?.[0] ?? null;
